module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAUBAMAAABPKxEfAAAAFVBMVEWVlZWdnZ1HcEyVlZWWlpaVlZWVlZUcvdR2AAAABnRSTlPUFQDTFmpxOfeiAAAAVElEQVQI12NQTXBSAgIGRTYWMK0kABZgUIIIMCgBBYTAtCIbI5gGC4BokACIBgmAaaAAlDaEiCcLQdQZQvQlC0HMMUQ2F2ws2F4hiDsYwe5QBXOVANHvEmsVEiZEAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/shop-cart-right-grey.png
// module id = jB7K
// module chunks = 42